import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import { Box, InputAdornment, TextField } from '@mui/material'
import 'react-datepicker/dist/react-datepicker.css'
import { de } from 'date-fns/locale'
import Wrapper from '../DatePickerWrapper'

interface DateRangePickerProps {
  startDate?: Date
  endDate?: Date
  onStartDateChange?: (date: Date | null) => void
  onEndDateChange?: (date: Date | null) => void
  [key: string]: any
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate: propStartDate,
  endDate: propEndDate,
  onStartDateChange,
  onEndDateChange,
  ...rest
}) => {
  const [startDate, setStartDate] = useState(propStartDate)
  const [endDate, setEndDate] = useState(propEndDate)
  useEffect(() => {
    if (startDate !== propStartDate) setStartDate(propStartDate)
    if (endDate !== propEndDate) setEndDate(propEndDate)
    // eslint-disable-next-line
  }, [propStartDate, propEndDate])
  return (
    <Wrapper>
      <DatePicker
        selected={startDate}
        onChange={date => {
          if (onStartDateChange) {
            onStartDateChange(date)
          } else {
            setStartDate(date ?? undefined)
          }
        }}
        selectsStart
        startDate={startDate}
        endDate={endDate}
        dateFormat="dd.MM.yyyy"
        customInput={
          <TextField
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <CalendarTodayIcon fontSize="small" />
                  </InputAdornment>
                )
              }
            }}
            size="small"
            sx={{
              '& .MuiOutlinedInput-input': {
                borderRight: `1px solid lightgrey`
              }
            }}
            label="Start"
            variant="outlined"
            {...rest}
          />
        }
        locale={de}
        monthsShown={1}
        showPopperArrow={false}
      />
      <Box
        sx={{
          m: 1
        }}
      />
      <DatePicker
        selected={endDate}
        onChange={date => {
          if (onEndDateChange) {
            onEndDateChange(date)
          } else {
            setEndDate(date ?? undefined)
          }
        }}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        minDate={startDate}
        dateFormat="dd.MM.yyyy"
        customInput={
          <TextField
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <CalendarTodayIcon fontSize="small" />
                  </InputAdornment>
                )
              }
            }}
            size="small"
            sx={{
              '& .MuiOutlinedInput-input': {
                borderRight: `1px solid lightgrey`
              }
            }}
            label="Ende"
            variant="outlined"
            {...rest}
          />
        }
        calendarClassName="material-calendar"
        locale={de}
        monthsShown={1}
        showPopperArrow={false}
      />
    </Wrapper>
  )
}
export default DateRangePicker
